// @ts-check

/**
 * @file Shared task-list sorting options and ransack expressions.
 */

import _ from "gettext-universal/build/src/translate.js"

export const DEFAULT_TASK_SORT_KEY = "newest"

/** @typedef {"newest" | "oldest" | "name_asc" | "name_desc"} TaskSortKey */

/** @typedef {{text: string, value: TaskSortKey}} TaskSortOption */

/**
 * Builds selectable task sort options.
 * @returns {TaskSortOption[]} Task sort select options.
 */
export function taskSortOptions() {
  return [
    {text: _("Newest first"), value: "newest"},
    {text: _("Oldest first"), value: "oldest"},
    {text: _("Name A-Z"), value: "name_asc"},
    {text: _("Name Z-A"), value: "name_desc"}
  ]
}

/**
 * Converts a task sort key into a ransack sort expression.
 * @param {TaskSortKey} sortKey Active task sort key.
 * @returns {string} Ransack sort expression.
 */
export function taskSortExpression(sortKey) {
  if (sortKey === "oldest") return "createdAt asc, id asc"
  if (sortKey === "name_asc") return "name asc, id asc"
  if (sortKey === "name_desc") return "name desc, id desc"
  return "createdAt desc, id desc"
}

/**
 * Parses select values into a whitelisted task sort key.
 * @param {unknown} value Raw sort key value.
 * @returns {TaskSortKey} Sort key accepted by task queries.
 */
export function parseTaskSortKey(value) {
  if (
    value === "newest" ||
    value === "oldest" ||
    value === "name_asc" ||
    value === "name_desc"
  ) {
    return value
  }

  return DEFAULT_TASK_SORT_KEY
}
